import React from "react";
import T from "prop-types";
import { useRouteMatch } from "react-router";
import cn from "classnames";

import { Route, Switch, useRouterProvider } from "2g-router";
import Widget from "2g-widget";

import { PAGE_TITLES, PATHS } from "b2b/constants";
import ProjektVytvoreni from "b2b/components/projekt-vytvoreni/ProjektVytvoreni";
import ProjektyGrid from "b2b/components/projekty-grid/ProjektyGrid";
import SmlouvaVytvoreni from "b2b/components/smlouva-vytvoreni/SmlouvaVytvoreni";
import SmlouvyGrid from "b2b/components/smlouvy-grid/SmlouvyGrid";
import UzivateleGrid from "b2b/components/uzivatele-grid/UzivateleGrid";
import { Zakaznik } from "b2b/renderers/ciselnik";

import ZakaznikDetailTitleDescription from "./ZakaznikDetailTitleDescription";

export function ZakaznikDetailContent({ zakaznik, loading }) {
  const { getPath } = useRouterProvider();
  const matchSmlouvaVytvoreni = useRouteMatch([
    getPath(PATHS.ADMINISTRACE.ZAKAZNIK_SMLOUVA)
  ]);
  const matchProjektVytvoreni = useRouteMatch([
    getPath(PATHS.ADMINISTRACE.ZAKAZNIK_PROJEKT)
  ]);

  return (
    <span
      className={cn("b2b-ZakaznikDetail", {
        "b2b-ZakaznikDetail-smlouvaVytvoreni": matchSmlouvaVytvoreni?.isExact,
        "b2b-ZakaznikDetail-projektVytvoreni": matchProjektVytvoreni?.isExact
      })}
    >
      <Widget
        title={<Zakaznik val={zakaznik} showPlaceholder={loading} />}
        collapsable={false}
        titleDescription={
          <ZakaznikDetailTitleDescription
            loading={loading}
            zakaznik={zakaznik}
          />
        }
        titleDescriptionOnlyBottom
      ></Widget>
      <Switch>
        <Route path={PATHS.ADMINISTRACE.ZAKAZNIK} exact>
          {zakaznik ? <SmlouvyGrid ico={zakaznik.ico} /> : undefined}
          {zakaznik ? <ProjektyGrid ico={zakaznik.ico} /> : undefined}
          {zakaznik ? <UzivateleGrid ico={zakaznik.ico} /> : undefined}
        </Route>
        <Route
          path={PATHS.ADMINISTRACE.ZAKAZNIK_SMLOUVA}
          title={PAGE_TITLES.ADMINISTRACE_SMLOUVA}
          exact
        >
          {zakaznik ? <SmlouvaVytvoreni zakaznik={zakaznik} /> : undefined}
        </Route>
        <Route
          path={PATHS.ADMINISTRACE.ZAKAZNIK_PROJEKT}
          title={PAGE_TITLES.ADMINISTRACE_PROJEKT}
          exact
        >
          {zakaznik ? <ProjektVytvoreni zakaznik={zakaznik} /> : undefined}
        </Route>
      </Switch>
    </span>
  );
}

ZakaznikDetailContent.propTypes = {
  zakaznik: T.object,
  loading: T.bool
};

export default React.memo(ZakaznikDetailContent);
